export default {
  viewType: 'delivery-deploy-project-detail',
  breadcrumb: {},
  params: {}
}
